import TodoDailyCDataFunc from "@/pcomponents/common/content/todo/todo_dailyc/data";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";

function TodoDailyCArea(props: any) {
  let myProps = {
    stu_info: {},
    row_check_val: "",
    subject_name: "",
    todo_dailyc_info: null,
    set_todo_dailyc_info: (inData: any) => { },
    is_show_memo: true,
    openTodoDailyCWritePopup: (inData: any) => { },
    go_todo_dailyc_write: (inData: any) => { },
    ...props
  };
  let row_check_val = myProps.row_check_val;
  let todo_dailyc_info = myProps.todo_dailyc_info;
  if (todo_dailyc_info == null) {
    todo_dailyc_info = {
      ...TodoDailyCDataFunc.default_info,
      a_subject: myProps.subject_name,
      a_stu_seq: myProps.stu_info.a_seq,
    };
  }
  let sort_select_arr = TodoDailyCDataFunc.sort_select_arr;

  let btn_wrap_style: any = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "5px",
  };
  let btn_style: any = {
    lineHeight: "30px",
    textAlign: "center",
    background: "#888",
    color: "#fff",
    minWidth: "50px",
    padding: "0px 4px",
    borderRadius: "8px",
  };

  const get_sort_btn_tags = () => {
    let tags = sort_select_arr.map((item: any, idx: number) => {
      let row_btn_style: any = { ...btn_style };

      if (todo_dailyc_info.a_sort == item.value) {
        row_btn_style["background"] = "#2e5251";
        row_btn_style["color"] = "#fff";
      }
      return (
        <button key={idx} style={row_btn_style}
          onClick={() => {
            if (item.value == "complete"&&todo_dailyc_info.a_sort=="") {
              myProps.go_todo_dailyc_write({
                check_row_val_arr: [row_check_val],
                todo_dailyc_sort: item.value,
                a_memo: todo_dailyc_info.a_memo,
              });
            } else {
              myProps.openTodoDailyCWritePopup({
                check_row_val_arr: [row_check_val],
                todo_dailyc_sort: item.value,
              });
            }

          }}>
          {item.text}
        </button>
      );
    });
    return tags;
  };
  return (
    <div style={{ position: "relative", width: "98%", margin: "0 auto" }}>
      <div style={btn_wrap_style} >
        {get_sort_btn_tags()}
      </div>
      {myProps.is_show_memo &&
        <div className="mt-1" title={todo_dailyc_info.a_memo} 
          style={{ minHeight: "25px",border:"1px solid #cfcfcfff",borderRadius:"4px" }}>
          <MultyLineTextView
            text={todo_dailyc_info.a_memo}
            style={{ color: "#888", background: "transparent"}}
          ></MultyLineTextView>
        </div>
      }
    </div>
  );
};
export default TodoDailyCArea;